"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SubscriptionFailReason = exports.StorybookColor = exports.SponsorType = exports.SortMode = exports.SocialMediaType = exports.SocialContactType = exports.ShowType = exports.ShoppingMessageType = exports.SettingsFormatType = exports.SettingsClientType = exports.ResponseMessageNewsletterSubsciptionsType = exports.ReportsVisitorSegment = exports.ReportType = exports.ReplacementType = exports.QuizAnswerIcon = exports.QuestionType = exports.PromotionType = exports.ProductType = exports.ProductReplacementType = exports.ProductRelationType = exports.ProductListingBannerVideoType = exports.ProductListType = exports.ProductLabelDomainType = exports.PlpOrderBy = exports.PickupSearchFilter = exports.PersonalSubscriptionCategory = exports.PermanentTopBannerType = exports.PeriodStatus = exports.PaymentMethodType = exports.PaymentChannel = exports.OrderStatus = exports.OrderOrigin = exports.OrderItemType = exports.OrderHistoryType = exports.OrderDocumentType = exports.OlapicTypeEnum = exports.NotificationBannerThemeType = exports.NotificationAppearance = exports.NavigationType = exports.NavigationLinkType = exports.MobileAppType = exports.ManagerSummitVersion = exports.ManagerSummitStatus = exports.LinkType = exports.LanguageType = exports.HorizontalContentAlignment = exports.HintType = exports.HintCategory = exports.Gender = exports.ForeignRegistrationStatus = exports.ForeignRegistrationOrigin = exports.FeedbackBenefitBannerType = exports.FeatureAccessMode = exports.EvaluationFilterType = exports.EditorialPlpPromoBannerSize = exports.EditorialContentType = exports.EditorialChannelType = exports.EditorialBenefitIcon = exports.EditorialBannerTitleSizeEnum = exports.EditorialBannerTitleColorEnum = exports.EditorialBannerLayoutEnum = exports.EWalletType = exports.DiscountType = exports.DeliverySearchFilter = exports.DeliveryMethodType = exports.CustomerCategory = exports.CurrentOrderStatus = exports.ComparisonTableCellType = exports.ColorType = exports.ClaimType = exports.ClaimStatus = exports.ClaimReasonType = exports.ClaimProductItemCategory = exports.ClaimHistoryCustomerType = exports.ClaimDeliveryMethodType = exports.ClaimCauseType = exports.ClaimCategoryType = exports.ClaimActionType = exports.ChatBotMode = exports.ChannelType = exports.CatalogueType = exports.CatalogueOfferType = exports.CanCancelOrderResult = exports.CampaignType = exports.CampaignCategory = exports.BonusBlockingReasonType = exports.BlockingType = exports.BlockingState = exports.BlockReason = exports.BcmNewActivityType = exports.BcmNewActivityDownlineType = exports.BankBonusPaymentTransferState = exports.BackgroundType = exports.BackInStockNotificationChannel = exports.ArticleType = exports.ApplyPolicy = exports.AllowedClaimExchangeProducts = exports.AdvancementBonusStatus = exports.AddressType = exports.AddressMetadataAllowedSearchResults = void 0;
exports.VoucherFlag = exports.VisitorSegment = exports.VideoType = exports.VerticalContentAlignment = exports.ValidationErrorType = exports.ValidationErrorSeverity = exports.TrackingStatus = exports.TelephoneType = void 0;
/* istanbul ignore file @preserve */ /**
  * DO NOT EDIT!
  * This file was autogenerated by graphql-codegen.
  * Changes may cause incorrect behavior and will be lost when the code is regenerated.
  *
  * Run `npx run codegen` to regenerate.
  */ /** All built-in and custom scalars, mapped to their actual values */ /** addThis configuration */ /** add this service */ /** Enum allowed search results */ let AddressMetadataAllowedSearchResults = exports.AddressMetadataAllowedSearchResults = /*#__PURE__*/ function(AddressMetadataAllowedSearchResults) {
    AddressMetadataAllowedSearchResults["Area"] = "Area";
    AddressMetadataAllowedSearchResults["City"] = "City";
    AddressMetadataAllowedSearchResults["Country"] = "Country";
    AddressMetadataAllowedSearchResults["District"] = "District";
    AddressMetadataAllowedSearchResults["Locality"] = "Locality";
    AddressMetadataAllowedSearchResults["Market"] = "Market";
    AddressMetadataAllowedSearchResults["Province"] = "Province";
    AddressMetadataAllowedSearchResults["Region"] = "Region";
    AddressMetadataAllowedSearchResults["Street"] = "Street";
    AddressMetadataAllowedSearchResults["ZipCode"] = "ZipCode";
    return AddressMetadataAllowedSearchResults;
}({});
/** Enum address type */ let AddressType = exports.AddressType = /*#__PURE__*/ function(AddressType) {
    AddressType["Channel"] = "Channel";
    AddressType["Delivery"] = "Delivery";
    AddressType["Foreign"] = "Foreign";
    AddressType["Home"] = "Home";
    AddressType["Kyc"] = "Kyc";
    AddressType["Other"] = "Other";
    return AddressType;
}({});
let AdvancementBonusStatus = exports.AdvancementBonusStatus = /*#__PURE__*/ function(AdvancementBonusStatus) {
    AdvancementBonusStatus["Completed"] = "COMPLETED";
    AdvancementBonusStatus["Failed"] = "FAILED";
    AdvancementBonusStatus["InProgress"] = "IN_PROGRESS";
    AdvancementBonusStatus["NotStarted"] = "NOT_STARTED";
    return AdvancementBonusStatus;
}({});
/** Product detail page advisors */ let AllowedClaimExchangeProducts = exports.AllowedClaimExchangeProducts = /*#__PURE__*/ function(AllowedClaimExchangeProducts) {
    AllowedClaimExchangeProducts["All"] = "All";
    AllowedClaimExchangeProducts["DifferentProductOnly"] = "DifferentProductOnly";
    AllowedClaimExchangeProducts["SameProductOnly"] = "SameProductOnly";
    return AllowedClaimExchangeProducts;
}({});
let ApplyPolicy = exports.ApplyPolicy = /*#__PURE__*/ function(ApplyPolicy) {
    ApplyPolicy["AfterResolver"] = "AFTER_RESOLVER";
    ApplyPolicy["BeforeResolver"] = "BEFORE_RESOLVER";
    ApplyPolicy["Validation"] = "VALIDATION";
    return ApplyPolicy;
}({});
let ArticleType = exports.ArticleType = /*#__PURE__*/ function(ArticleType) {
    /** Articles from Beauty Edit section */ ArticleType["BeautyEdit"] = "BeautyEdit";
    /** Articles related to products */ ArticleType["RelatedToProduct"] = "RelatedToProduct";
    /** Default value - not for use with API. Exists to detect errors in parsing values */ ArticleType["Undefined"] = "Undefined";
    return ArticleType;
}({});
/** Channel to identify how we should notify user */ let BackInStockNotificationChannel = exports.BackInStockNotificationChannel = /*#__PURE__*/ function(BackInStockNotificationChannel) {
    /** We will notify customer on provided email */ BackInStockNotificationChannel["Email"] = "Email";
    /** We will notify customer on provided telephone */ BackInStockNotificationChannel["Sms"] = "Sms";
    return BackInStockNotificationChannel;
}({});
/** Background types */ let BackgroundType = exports.BackgroundType = /*#__PURE__*/ function(BackgroundType) {
    /** Color as a background */ BackgroundType["Color"] = "Color";
    /** Image as a background */ BackgroundType["Image"] = "Image";
    /** No background */ BackgroundType["None"] = "None";
    /** Video as a background */ BackgroundType["Video"] = "Video";
    return BackgroundType;
}({});
let BankBonusPaymentTransferState = exports.BankBonusPaymentTransferState = /*#__PURE__*/ function(BankBonusPaymentTransferState) {
    BankBonusPaymentTransferState["Blocked"] = "Blocked";
    BankBonusPaymentTransferState["NothingForTransfer"] = "NothingForTransfer";
    BankBonusPaymentTransferState["Pending"] = "Pending";
    BankBonusPaymentTransferState["Transferred"] = "Transferred";
    BankBonusPaymentTransferState["Undefined"] = "Undefined";
    return BankBonusPaymentTransferState;
}({});
let BcmNewActivityDownlineType = exports.BcmNewActivityDownlineType = /*#__PURE__*/ function(BcmNewActivityDownlineType) {
    BcmNewActivityDownlineType["PersonalGroupPlusAuthorizedPgLeadersInFirstLevel"] = "PERSONAL_GROUP_PLUS_AUTHORIZED_PG_LEADERS_IN_FIRST_LEVEL";
    BcmNewActivityDownlineType["PgLeaders"] = "PG_LEADERS";
    return BcmNewActivityDownlineType;
}({});
let BcmNewActivityType = exports.BcmNewActivityType = /*#__PURE__*/ function(BcmNewActivityType) {
    BcmNewActivityType["Active"] = "Active";
    BcmNewActivityType["AllBasicView"] = "AllBasicView";
    BcmNewActivityType["AllFullView"] = "AllFullView";
    BcmNewActivityType["AllSplitouts"] = "AllSplitouts";
    BcmNewActivityType["AllStandardView"] = "AllStandardView";
    BcmNewActivityType["ExpiringWalletAmount"] = "ExpiringWalletAmount";
    BcmNewActivityType["FirstLevel"] = "FirstLevel";
    BcmNewActivityType["Inactives"] = "Inactives";
    BcmNewActivityType["NewStarters"] = "NewStarters";
    BcmNewActivityType["NotSellingWellness"] = "NotSellingWellness";
    BcmNewActivityType["Recruits"] = "Recruits";
    BcmNewActivityType["SellingWellness"] = "SellingWellness";
    BcmNewActivityType["Sleeping"] = "Sleeping";
    BcmNewActivityType["Starters"] = "Starters";
    BcmNewActivityType["UpgradedMembers"] = "UpgradedMembers";
    return BcmNewActivityType;
}({});
/** Block Reason */ let BlockReason = exports.BlockReason = /*#__PURE__*/ function(BlockReason) {
    /** Can't order */ BlockReason["CantOrder"] = "CantOrder";
    /** Can't order on credit */ BlockReason["CantOrderOnCredit"] = "CantOrderOnCredit";
    /** More than max. unpaid card/online payment orders */ BlockReason["CardUnpaidLimit"] = "CardUnpaidLimit";
    /** The others payment methods will be blocked in case that there is maximum pending orders with online payment */ BlockReason["CardUnpaidLimitBlockingOthers"] = "CardUnpaidLimitBlockingOthers";
    /** More than max. unpaid cash orders */ BlockReason["CashUnpaidLimit"] = "CashUnpaidLimit";
    /** The others payment methods will be blocked in case that there is maximum pending orders on cash */ BlockReason["CashUnpaidLimitBlockingOthers"] = "CashUnpaidLimitBlockingOthers";
    /** More than max. unpaid COD orders */ BlockReason["CodUnpaidLimit"] = "CodUnpaidLimit";
    /** The others payment methods will be blocked in case that there is maximum pending orders on COD */ BlockReason["CodUnpaidLimitBlockingOthers"] = "CodUnpaidLimitBlockingOthers";
    /** Credit limit exceeded */ BlockReason["CreditLimit"] = "CreditLimit";
    /** More than max unpaid Credit orders */ BlockReason["CreditUnpaidLimit"] = "CreditUnpaidLimit";
    /** The others payment methods will be blocked in case that there is maximum pending orders on credit */ BlockReason["CreditUnpaidLimitBlockingOthers"] = "CreditUnpaidLimitBlockingOthers";
    /** Selected home delivery address is different than home branch */ BlockReason["CrossBranch"] = "CrossBranch";
    /** More than max unpaid orders for customer */ BlockReason["CustomerTotalUnpaidLimit"] = "CustomerTotalUnpaidLimit";
    /** Invoice payment method will be blocked if unique id is empty - then credibility check cannot proceed */ BlockReason["EmptyUniqueId"] = "EmptyUniqueId";
    /** Over max debt limit */ BlockReason["MaxAmount"] = "MaxAmount";
    /** Less than min debt limit */ BlockReason["MinAmount"] = "MinAmount";
    /** Customer has not set any birthdate */ BlockReason["MissingCustomerBirthDate"] = "MissingCustomerBirthDate";
    /** Customer has not set any email */ BlockReason["MissingCustomerEmail"] = "MissingCustomerEmail";
    /** Customer has not set any telephone */ BlockReason["MissingCustomerTelephone"] = "MissingCustomerTelephone";
    /** Not allowed to use recurring for VIP order */ BlockReason["NotAllowedRecurringForVipOrder"] = "NotAllowedRecurringForVipOrder";
    /** One-step payment provider not allowed for OOB flow */ BlockReason["OneStepProviderNotAllowedForOob"] = "OneStepProviderNotAllowedForOob";
    /** Overdue orders */ BlockReason["OverdueOrders"] = "OverdueOrders";
    /** More pending orders than allowed */ BlockReason["PendingLimit"] = "PendingLimit";
    /** Telephone number is not valid */ BlockReason["TelephoneNumberIsNotValid"] = "TelephoneNumberIsNotValid";
    /** Terminated consultant */ BlockReason["Terminated"] = "Terminated";
    /** Unpaid interest */ BlockReason["UnpaidInterest"] = "UnpaidInterest";
    /** More than max unpaid orders for vip customer */ BlockReason["VipTotalUnpaidLimit"] = "VipTotalUnpaidLimit";
    /** More than max. unpaid WFT orders */ BlockReason["WftUnpaidLimit"] = "WftUnpaidLimit";
    /** The others payment methods will be blocked in case that there is maximum pending orders on wft */ BlockReason["WftUnpaidLimitBlockingOthers"] = "WftUnpaidLimitBlockingOthers";
    /** Total debt is 0 */ BlockReason["ZeroDebt"] = "ZeroDebt";
    return BlockReason;
}({});
let BlockingState = exports.BlockingState = /*#__PURE__*/ function(BlockingState) {
    BlockingState["Expired"] = "Expired";
    BlockingState["Future"] = "Future";
    BlockingState["Valid"] = "Valid";
    return BlockingState;
}({});
let BlockingType = exports.BlockingType = /*#__PURE__*/ function(BlockingType) {
    BlockingType["ApproveDocument"] = "ApproveDocument";
    BlockingType["Claim"] = "Claim";
    BlockingType["GetBonuses"] = "GetBonuses";
    BlockingType["Login"] = "Login";
    BlockingType["OnBehalf"] = "OnBehalf";
    BlockingType["Order"] = "Order";
    BlockingType["OrderOnCredit"] = "OrderOnCredit";
    BlockingType["Other"] = "Other";
    BlockingType["PageAccess"] = "PageAccess";
    BlockingType["PayByCheque"] = "PayByCheque";
    BlockingType["Recruit"] = "Recruit";
    return BlockingType;
}({});
/** Blocking reasons in case of blocked transfer */ /** Reason of blocked payment */ let BonusBlockingReasonType = exports.BonusBlockingReasonType = /*#__PURE__*/ function(BonusBlockingReasonType) {
    BonusBlockingReasonType["BonusBelowMinimumAmountToRelease"] = "BonusBelowMinimumAmountToRelease";
    BonusBlockingReasonType["CustomInfo"] = "CustomInfo";
    BonusBlockingReasonType["ManualBlock"] = "ManualBlock";
    BonusBlockingReasonType["MissingBankInformation"] = "MissingBankInformation";
    BonusBlockingReasonType["OverdueDebt"] = "OverdueDebt";
    BonusBlockingReasonType["Undefined"] = "Undefined";
    return BonusBlockingReasonType;
}({});
/** The bundle component resolver. */ let CampaignCategory = exports.CampaignCategory = /*#__PURE__*/ function(CampaignCategory) {
    /** Loyalty campaign (Beauty rewards) */ CampaignCategory["Loyalty"] = "Loyalty";
    /** Recruitment campaign */ CampaignCategory["Recruitment"] = "Recruitment";
    return CampaignCategory;
}({});
let CampaignType = exports.CampaignType = /*#__PURE__*/ function(CampaignType) {
    /** Gamification rewards */ CampaignType["Gamification"] = "Gamification";
    /** Default generic campaign */ CampaignType["Generic"] = "Generic";
    /** CIS recruitment campaign */ CampaignType["InvitedRecruits"] = "InvitedRecruits";
    /** VIP loyalty without reward shop */ CampaignType["LightVipLoyalty"] = "LightVipLoyalty";
    /** Loyalty campaign (known as product program in Orisales) */ CampaignType["Loyalty"] = "Loyalty";
    /** Member get member program (China) */ CampaignType["Mgm"] = "Mgm";
    /** Mature market loyalty for brand partners */ CampaignType["MmLoyalty"] = "MmLoyalty";
    /** VIP loyalty (Reward shop) */ CampaignType["VipLoyalty"] = "VipLoyalty";
    return CampaignType;
}({});
let CanCancelOrderResult = exports.CanCancelOrderResult = /*#__PURE__*/ function(CanCancelOrderResult) {
    CanCancelOrderResult["Allowed"] = "Allowed";
    CanCancelOrderResult["AlreadyCancelled"] = "AlreadyCancelled";
    CanCancelOrderResult["AlreadyRequested"] = "AlreadyRequested";
    CanCancelOrderResult["CancellationNotAllowedByOrderFlow"] = "CancellationNotAllowedByOrderFlow";
    CanCancelOrderResult["CancellationNotAllowedByOrisales"] = "CancellationNotAllowedByOrisales";
    CanCancelOrderResult["CancellationOfOrdersWithGiftCardsIsDisabled"] = "CancellationOfOrdersWithGiftCardsIsDisabled";
    CanCancelOrderResult["FinalizedNotSynchronized"] = "FinalizedNotSynchronized";
    CanCancelOrderResult["Hidden"] = "Hidden";
    CanCancelOrderResult["InsufficientPermissions"] = "InsufficientPermissions";
    CanCancelOrderResult["IsFromOrisales"] = "IsFromOrisales";
    CanCancelOrderResult["IsNotAllowedPeriodOrder"] = "IsNotAllowedPeriodOrder";
    CanCancelOrderResult["IsNotCurrentPeriodOrder"] = "IsNotCurrentPeriodOrder";
    CanCancelOrderResult["IsOrderOriginPharmacy"] = "IsOrderOriginPharmacy";
    CanCancelOrderResult["IsPaidOnline"] = "IsPaidOnline";
    CanCancelOrderResult["IsPrinted"] = "IsPrinted";
    CanCancelOrderResult["PendingOnlinePayment"] = "PendingOnlinePayment";
    CanCancelOrderResult["PeriodClosingMinutesOffset"] = "PeriodClosingMinutesOffset";
    CanCancelOrderResult["PlaceOrderMinutesOffset"] = "PlaceOrderMinutesOffset";
    CanCancelOrderResult["RedeemedGiftCard"] = "RedeemedGiftCard";
    return CanCancelOrderResult;
}({});
/** Represents the information of a catalogue. */ let CatalogueOfferType = exports.CatalogueOfferType = /*#__PURE__*/ function(CatalogueOfferType) {
    /** Special offer for buying product */ CatalogueOfferType["Buy"] = "Buy";
    /** Choose from products */ CatalogueOfferType["Choose"] = "Choose";
    /** Choose a product and choose another */ CatalogueOfferType["ChooseAndChoose"] = "ChooseAndChoose";
    /** Choose a product and get another */ CatalogueOfferType["ChooseAndGet"] = "ChooseAndGet";
    /** Get a product */ CatalogueOfferType["Get"] = "Get";
    /** No type of catalogue offer was specified */ CatalogueOfferType["None"] = "None";
    return CatalogueOfferType;
}({});
let CatalogueType = exports.CatalogueType = /*#__PURE__*/ function(CatalogueType) {
    /** DigitalCurrent catalogue type */ CatalogueType["DigitalCurrent"] = "DigitalCurrent";
    /** DigitalNext catalogue type */ CatalogueType["DigitalNext"] = "DigitalNext";
    /** LocalCustom catalogue type */ CatalogueType["LocalCustom"] = "LocalCustom";
    /** Lookbook catalogue type */ CatalogueType["Lookbook"] = "Lookbook";
    CatalogueType["None"] = "None";
    return CatalogueType;
}({});
let ChannelType = exports.ChannelType = /*#__PURE__*/ function(ChannelType) {
    ChannelType["Mv7"] = "MV7";
    ChannelType["Website"] = "Website";
    return ChannelType;
}({});
/** The concept resolver. */ /** The concept resolver. */ /** The concept resolver. */ let ChatBotMode = exports.ChatBotMode = /*#__PURE__*/ function(ChatBotMode) {
    ChatBotMode["AlwaysEnabled"] = "AlwaysEnabled";
    ChatBotMode["Disabled"] = "Disabled";
    ChatBotMode["NonBusinessHoursOnly"] = "NonBusinessHoursOnly";
    return ChatBotMode;
}({});
let ClaimActionType = exports.ClaimActionType = /*#__PURE__*/ function(ClaimActionType) {
    ClaimActionType["CancelOrder"] = "CancelOrder";
    ClaimActionType["CancelProduct"] = "CancelProduct";
    ClaimActionType["ExchangeProduct"] = "ExchangeProduct";
    ClaimActionType["None"] = "None";
    ClaimActionType["ResendOrder"] = "ResendOrder";
    ClaimActionType["ResendProduct"] = "ResendProduct";
    ClaimActionType["ReturnProduct"] = "ReturnProduct";
    return ClaimActionType;
}({});
let ClaimCategoryType = exports.ClaimCategoryType = /*#__PURE__*/ function(ClaimCategoryType) {
    ClaimCategoryType["DistributionIssue"] = "DistributionIssue";
    ClaimCategoryType["Exchange"] = "Exchange";
    ClaimCategoryType["InvoiceIssue"] = "InvoiceIssue";
    ClaimCategoryType["Missing"] = "Missing";
    ClaimCategoryType["ProductJustMissing"] = "ProductJustMissing";
    ClaimCategoryType["Return"] = "Return";
    ClaimCategoryType["ReturnExchangeMissing"] = "ReturnExchangeMissing";
    ClaimCategoryType["Root"] = "Root";
    ClaimCategoryType["WrongProductDelivered"] = "WrongProductDelivered";
    return ClaimCategoryType;
}({});
let ClaimCauseType = exports.ClaimCauseType = /*#__PURE__*/ function(ClaimCauseType) {
    ClaimCauseType["AdverseReaction"] = "AdverseReaction";
    ClaimCauseType["CancelOrder"] = "CancelOrder";
    ClaimCauseType["DamagedOrDefectedProduct"] = "DamagedOrDefectedProduct";
    ClaimCauseType["ExtraProductReceivedMissingOnTheInvoice"] = "ExtraProductReceivedMissingOnTheInvoice";
    ClaimCauseType["ExtraProductReceivedWrongQuantity"] = "ExtraProductReceivedWrongQuantity";
    ClaimCauseType["InvoiceCampaignProductMissing"] = "InvoiceCampaignProductMissing";
    ClaimCauseType["InvoiceWrongPriceOrFee"] = "InvoiceWrongPriceOrFee";
    ClaimCauseType["MissingProduct"] = "MissingProduct";
    ClaimCauseType["ParcelDamaged"] = "ParcelDamaged";
    ClaimCauseType["ParcelNotDelivered"] = "ParcelNotDelivered";
    ClaimCauseType["ParcelRefused"] = "ParcelRefused";
    ClaimCauseType["RefundReturnCost"] = "RefundReturnCost";
    ClaimCauseType["SupplementaryProduct"] = "SupplementaryProduct";
    ClaimCauseType["UncollectedParcel"] = "UncollectedParcel";
    ClaimCauseType["UnwantedProduct"] = "UnwantedProduct";
    ClaimCauseType["WrongPriceFix"] = "WrongPriceFix";
    ClaimCauseType["WrongProductDelivered"] = "WrongProductDelivered";
    return ClaimCauseType;
}({});
let ClaimDeliveryMethodType = exports.ClaimDeliveryMethodType = /*#__PURE__*/ function(ClaimDeliveryMethodType) {
    ClaimDeliveryMethodType["DepartmentStore"] = "DepartmentStore";
    ClaimDeliveryMethodType["Home"] = "Home";
    ClaimDeliveryMethodType["LastUsed"] = "LastUsed";
    ClaimDeliveryMethodType["Lpo"] = "Lpo";
    ClaimDeliveryMethodType["NearestPostOffice"] = "NearestPostOffice";
    ClaimDeliveryMethodType["NextOrder"] = "NextOrder";
    ClaimDeliveryMethodType["ParcelLocker"] = "ParcelLocker";
    ClaimDeliveryMethodType["PickupPoint"] = "PickupPoint";
    ClaimDeliveryMethodType["PostOffice"] = "PostOffice";
    ClaimDeliveryMethodType["Spo"] = "Spo";
    return ClaimDeliveryMethodType;
}({});
let ClaimHistoryCustomerType = exports.ClaimHistoryCustomerType = /*#__PURE__*/ function(ClaimHistoryCustomerType) {
    ClaimHistoryCustomerType["BrandPartners"] = "BrandPartners";
    ClaimHistoryCustomerType["Customers"] = "Customers";
    ClaimHistoryCustomerType["Employees"] = "Employees";
    return ClaimHistoryCustomerType;
}({});
let ClaimProductItemCategory = exports.ClaimProductItemCategory = /*#__PURE__*/ function(ClaimProductItemCategory) {
    ClaimProductItemCategory["AddOns"] = "AddOns";
    ClaimProductItemCategory["Cosmetics"] = "Cosmetics";
    ClaimProductItemCategory["DemoProduct"] = "DemoProduct";
    ClaimProductItemCategory["Fee"] = "Fee";
    ClaimProductItemCategory["Jewellery"] = "Jewellery";
    ClaimProductItemCategory["NonFinancial"] = "NonFinancial";
    ClaimProductItemCategory["None"] = "None";
    ClaimProductItemCategory["Other"] = "Other";
    ClaimProductItemCategory["OtherSample"] = "OtherSample";
    ClaimProductItemCategory["Packaging"] = "Packaging";
    ClaimProductItemCategory["PrintingMaterial"] = "PrintingMaterial";
    ClaimProductItemCategory["RecruitmentGifts"] = "RecruitmentGifts";
    ClaimProductItemCategory["Training"] = "Training";
    ClaimProductItemCategory["Unknown"] = "Unknown";
    ClaimProductItemCategory["Wellness"] = "Wellness";
    return ClaimProductItemCategory;
}({});
let ClaimReasonType = exports.ClaimReasonType = /*#__PURE__*/ function(ClaimReasonType) {
    ClaimReasonType["BatchNumberOrExpiryDateMissingNotReadable"] = "BatchNumberOrExpiryDateMissingNotReadable";
    ClaimReasonType["ColorVariation"] = "ColorVariation";
    ClaimReasonType["ConsistencyColorOrScentIssue"] = "ConsistencyColorOrScentIssue";
    ClaimReasonType["ConsistencyOrTextureVariation"] = "ConsistencyOrTextureVariation";
    ClaimReasonType["ContaminatedByForeignObject"] = "ContaminatedByForeignObject";
    ClaimReasonType["ContentDamagedByLeakageFromAnotherProduct"] = "ContentDamagedByLeakageFromAnotherProduct";
    ClaimReasonType["DamagedByAnotherProduct"] = "DamagedByAnotherProduct";
    ClaimReasonType["DamagedContainerJarTubeBottlePouch"] = "DamagedContainerJarTubeBottlePouch";
    ClaimReasonType["DamagedOrDeformed"] = "DamagedOrDeformed";
    ClaimReasonType["DamagedOrDeformed_22"] = "DamagedOrDeformed_22";
    ClaimReasonType["DamagedPackagingExternalProductBoxTamperProofPolybagFoil"] = "DamagedPackagingExternalProductBoxTamperProofPolybagFoil";
    ClaimReasonType["DescriptionFoundInCatalogue"] = "DescriptionFoundInCatalogue";
    ClaimReasonType["DescriptionFoundInOtherCommunication"] = "DescriptionFoundInOtherCommunication";
    ClaimReasonType["DescriptionFoundOnline"] = "DescriptionFoundOnline";
    ClaimReasonType["DidntMatchTheProductDescription"] = "DidntMatchTheProductDescription";
    ClaimReasonType["DidntMeetExpectations"] = "DidntMeetExpectations";
    ClaimReasonType["DifferentProductThanStatedOnPackOrLabel"] = "DifferentProductThanStatedOnPackOrLabel";
    ClaimReasonType["ForeignMatter"] = "ForeignMatter";
    ClaimReasonType["Leakage"] = "Leakage";
    ClaimReasonType["Malfunction"] = "Malfunction";
    ClaimReasonType["MechanismProblems"] = "MechanismProblems";
    ClaimReasonType["MissingLabelOrLeaflet"] = "MissingLabelOrLeaflet";
    ClaimReasonType["MissingPart"] = "MissingPart";
    ClaimReasonType["MissingPartsOrUnderfilled"] = "MissingPartsOrUnderfilled";
    ClaimReasonType["NoReasonJustChangedMyMind"] = "NoReasonJustChangedMyMind";
    ClaimReasonType["NotUsedProduct"] = "NotUsedProduct";
    ClaimReasonType["NotUsedProductNoReason"] = "NotUsedProductNoReason";
    ClaimReasonType["NotUsedProductNotMeetExpectations"] = "NotUsedProductNotMeetExpectations";
    ClaimReasonType["NotWorkingAtAll"] = "NotWorkingAtAll";
    ClaimReasonType["PackagingDamagedByLeakageFromAnotherProduct"] = "PackagingDamagedByLeakageFromAnotherProduct";
    ClaimReasonType["PackagingQualityIssue"] = "PackagingQualityIssue";
    ClaimReasonType["ParcelDelayed"] = "ParcelDelayed";
    ClaimReasonType["ParcelIsLost"] = "ParcelIsLost";
    ClaimReasonType["PoorLabelling"] = "PoorLabelling";
    ClaimReasonType["ProductContentQualityIssue"] = "ProductContentQualityIssue";
    ClaimReasonType["ProductIsLeaking"] = "ProductIsLeaking";
    ClaimReasonType["SmellChangedOrUnpleasant"] = "SmellChangedOrUnpleasant";
    ClaimReasonType["TasteChangedOrUnpleasant"] = "TasteChangedOrUnpleasant";
    ClaimReasonType["UsedProduct"] = "UsedProduct";
    ClaimReasonType["UsedProductNoReason"] = "UsedProductNoReason";
    ClaimReasonType["UsedProductNotMeetExpectations"] = "UsedProductNotMeetExpectations";
    ClaimReasonType["WorkingPoorly"] = "WorkingPoorly";
    ClaimReasonType["WrongAddress"] = "WrongAddress";
    ClaimReasonType["WrongProductOrdered"] = "WrongProductOrdered";
    ClaimReasonType["WrongQuantity"] = "WrongQuantity";
    return ClaimReasonType;
}({});
let ClaimStatus = exports.ClaimStatus = /*#__PURE__*/ function(ClaimStatus) {
    ClaimStatus["Approved"] = "Approved";
    ClaimStatus["Created"] = "Created";
    ClaimStatus["Denied"] = "Denied";
    ClaimStatus["Finished"] = "Finished";
    ClaimStatus["PartiallyApproved"] = "PartiallyApproved";
    ClaimStatus["Saved"] = "Saved";
    return ClaimStatus;
}({});
let ClaimType = exports.ClaimType = /*#__PURE__*/ function(ClaimType) {
    ClaimType["DistributionIssue"] = "DistributionIssue";
    ClaimType["InvoiceIssue"] = "InvoiceIssue";
    ClaimType["ReturnExchangeOrMissingProduct"] = "ReturnExchangeOrMissingProduct";
    return ClaimType;
}({});
/** Claiming query root */ /** Claiming query root */ /** Claiming query root */ /** Claiming query root */ /** Claiming query root */ /** Color type */ let ColorType = exports.ColorType = /*#__PURE__*/ function(ColorType) {
    ColorType["Brown"] = "Brown";
    ColorType["Green"] = "Green";
    ColorType["White"] = "White";
    return ColorType;
}({});
let ComparisonTableCellType = exports.ComparisonTableCellType = /*#__PURE__*/ function(ComparisonTableCellType) {
    ComparisonTableCellType["No"] = "No";
    ComparisonTableCellType["Text"] = "Text";
    ComparisonTableCellType["Unknown"] = "Unknown";
    ComparisonTableCellType["Yes"] = "Yes";
    return ComparisonTableCellType;
}({});
/** The concept resolver. */ let CurrentOrderStatus = exports.CurrentOrderStatus = /*#__PURE__*/ function(CurrentOrderStatus) {
    CurrentOrderStatus["Blocked"] = "Blocked";
    CurrentOrderStatus["CancelRequested"] = "CancelRequested";
    CurrentOrderStatus["Canceled"] = "Canceled";
    CurrentOrderStatus["CreditNote"] = "CreditNote";
    CurrentOrderStatus["Paid"] = "Paid";
    CurrentOrderStatus["PaidPartially"] = "PaidPartially";
    CurrentOrderStatus["Pending"] = "Pending";
    CurrentOrderStatus["Unknown"] = "Unknown";
    CurrentOrderStatus["Unpaid"] = "Unpaid";
    CurrentOrderStatus["Waiting"] = "Waiting";
    CurrentOrderStatus["WaitingForApproval"] = "WaitingForApproval";
    return CurrentOrderStatus;
}({});
/** Enum customer category */ let CustomerCategory = exports.CustomerCategory = /*#__PURE__*/ function(CustomerCategory) {
    CustomerCategory["Anonymous"] = "Anonymous";
    CustomerCategory["Consultant"] = "Consultant";
    CustomerCategory["Employee"] = "Employee";
    CustomerCategory["EndConsumer"] = "EndConsumer";
    CustomerCategory["EndCustomer"] = "EndCustomer";
    CustomerCategory["Invitation"] = "Invitation";
    CustomerCategory["Other"] = "Other";
    return CustomerCategory;
}({});
let DeliveryMethodType = exports.DeliveryMethodType = /*#__PURE__*/ function(DeliveryMethodType) {
    DeliveryMethodType["DepartmentStore"] = "DepartmentStore";
    DeliveryMethodType["Home"] = "Home";
    DeliveryMethodType["Lpo"] = "Lpo";
    DeliveryMethodType["NearestPostOffice"] = "NearestPostOffice";
    DeliveryMethodType["NextOrder"] = "NextOrder";
    DeliveryMethodType["ParcelLocker"] = "ParcelLocker";
    DeliveryMethodType["PickupPoint"] = "PickupPoint";
    DeliveryMethodType["PostOffice"] = "PostOffice";
    DeliveryMethodType["Spo"] = "Spo";
    return DeliveryMethodType;
}({});
let DeliverySearchFilter = exports.DeliverySearchFilter = /*#__PURE__*/ function(DeliverySearchFilter) {
    DeliverySearchFilter["AllAddresses"] = "AllAddresses";
    DeliverySearchFilter["DepartmentStore"] = "DepartmentStore";
    DeliverySearchFilter["History"] = "History";
    DeliverySearchFilter["Lpo"] = "Lpo";
    DeliverySearchFilter["MyAddresses"] = "MyAddresses";
    DeliverySearchFilter["MyFriends"] = "MyFriends";
    DeliverySearchFilter["MyHistoryAddresses"] = "MyHistoryAddresses";
    DeliverySearchFilter["MyHistoryFriends"] = "MyHistoryFriends";
    DeliverySearchFilter["MySpo"] = "MySpo";
    DeliverySearchFilter["PickUp"] = "PickUp";
    DeliverySearchFilter["PostOffice"] = "PostOffice";
    DeliverySearchFilter["PremiumSpo"] = "PremiumSpo";
    DeliverySearchFilter["Spo"] = "Spo";
    return DeliverySearchFilter;
}({});
/** Discount applied to reduce price of the order */ let DiscountType = exports.DiscountType = /*#__PURE__*/ function(DiscountType) {
    DiscountType["Direct"] = "Direct";
    DiscountType["Employee"] = "Employee";
    DiscountType["Extra"] = "Extra";
    DiscountType["GiftCard"] = "GiftCard";
    DiscountType["Immediate"] = "Immediate";
    DiscountType["Invitation"] = "Invitation";
    DiscountType["Merchandising"] = "Merchandising";
    DiscountType["ProductVoucher"] = "ProductVoucher";
    DiscountType["PromoCode"] = "PromoCode";
    DiscountType["Staggered"] = "Staggered";
    DiscountType["Voucher"] = "Voucher";
    DiscountType["Welcome"] = "Welcome";
    return DiscountType;
}({});
/** eWallet type */ let EWalletType = exports.EWalletType = /*#__PURE__*/ function(EWalletType) {
    EWalletType["Revolut"] = "Revolut";
    return EWalletType;
}({});
/** Editorial banner */ /** Editorial banner color */ /** Editorial banner content */ /** Banner background image */ /** Editorial banner layout enumeration */ let EditorialBannerLayoutEnum = exports.EditorialBannerLayoutEnum = /*#__PURE__*/ function(EditorialBannerLayoutEnum) {
    /** Big CTA button */ EditorialBannerLayoutEnum["BigCtaButton"] = "BigCtaButton";
    /** 50/50 banner */ EditorialBannerLayoutEnum["FiftyBanner"] = "FiftyBanner";
    /** Banner with four media */ EditorialBannerLayoutEnum["FourMedia"] = "FourMedia";
    /** Banner with headline */ EditorialBannerLayoutEnum["Headline"] = "Headline";
    /** Banner with one media overlayed with text at the bottom */ EditorialBannerLayoutEnum["OneMediaCenterBottomText"] = "OneMediaCenterBottomText";
    /** Banner with one media overlayed with text on the left */ EditorialBannerLayoutEnum["OneMediaOverlayLeftText"] = "OneMediaOverlayLeftText";
    /** Banner with one media overlayed with text on the right */ EditorialBannerLayoutEnum["OneMediaOverlayRightText"] = "OneMediaOverlayRightText";
    /** Banner with one media part and paragraph text */ EditorialBannerLayoutEnum["OneMediaParagraphText"] = "OneMediaParagraphText";
    /** PLP banner with single media */ EditorialBannerLayoutEnum["OneMediaProductPromo"] = "OneMediaProductPromo";
    /** Banner with paragraph text */ EditorialBannerLayoutEnum["ParagraphText"] = "ParagraphText";
    /** Banner with quote */ EditorialBannerLayoutEnum["Quote"] = "Quote";
    /** Small CTA button */ EditorialBannerLayoutEnum["SmallCtaButton"] = "SmallCtaButton";
    /** Banner with three media and right bottom text */ EditorialBannerLayoutEnum["ThreeMediaRightBottomText"] = "ThreeMediaRightBottomText";
    /** Banner with two media parts */ EditorialBannerLayoutEnum["TwoMedia"] = "TwoMedia";
    /** Banner with two media overlayed with text on the top */ EditorialBannerLayoutEnum["TwoMediaRightTopText"] = "TwoMediaRightTopText";
    /** Banner with vertical video */ EditorialBannerLayoutEnum["VerticalVideo"] = "VerticalVideo";
    /** Banner with video */ EditorialBannerLayoutEnum["Video"] = "Video";
    return EditorialBannerLayoutEnum;
}({});
/** Banner modules */ /** Text wrapper */ /** Editorial banner title color enumeration */ let EditorialBannerTitleColorEnum = exports.EditorialBannerTitleColorEnum = /*#__PURE__*/ function(EditorialBannerTitleColorEnum) {
    /** The black */ EditorialBannerTitleColorEnum["Black"] = "Black";
    /** The dark grey */ EditorialBannerTitleColorEnum["DarkGrey"] = "DarkGrey";
    /** The white */ EditorialBannerTitleColorEnum["White"] = "White";
    return EditorialBannerTitleColorEnum;
}({});
/** Editorial banner title size enumeration */ let EditorialBannerTitleSizeEnum = exports.EditorialBannerTitleSizeEnum = /*#__PURE__*/ function(EditorialBannerTitleSizeEnum) {
    EditorialBannerTitleSizeEnum["H5"] = "H5";
    EditorialBannerTitleSizeEnum["H6"] = "H6";
    return EditorialBannerTitleSizeEnum;
}({});
let EditorialBenefitIcon = exports.EditorialBenefitIcon = /*#__PURE__*/ function(EditorialBenefitIcon) {
    EditorialBenefitIcon["BubbleHeart"] = "BubbleHeart";
    EditorialBenefitIcon["Cashback"] = "Cashback";
    EditorialBenefitIcon["Check"] = "Check";
    EditorialBenefitIcon["Conference"] = "Conference";
    EditorialBenefitIcon["DiscountTag"] = "DiscountTag";
    EditorialBenefitIcon["Dollar"] = "Dollar";
    EditorialBenefitIcon["Gift"] = "Gift";
    EditorialBenefitIcon["Send"] = "Send";
    EditorialBenefitIcon["Share"] = "Share";
    EditorialBenefitIcon["Truck"] = "Truck";
    EditorialBenefitIcon["Wallet"] = "Wallet";
    EditorialBenefitIcon["WelcomeKit"] = "WelcomeKit";
    return EditorialBenefitIcon;
}({});
/** Editorial channel type */ let EditorialChannelType = exports.EditorialChannelType = /*#__PURE__*/ function(EditorialChannelType) {
    EditorialChannelType["Mobile"] = "Mobile";
    EditorialChannelType["Web"] = "Web";
    return EditorialChannelType;
}({});
let EditorialContentType = exports.EditorialContentType = /*#__PURE__*/ function(EditorialContentType) {
    EditorialContentType["Banner"] = "Banner";
    EditorialContentType["Benefits"] = "Benefits";
    EditorialContentType["EditorialBannerCarousel"] = "EditorialBannerCarousel";
    EditorialContentType["EditorialCarousel"] = "EditorialCarousel";
    EditorialContentType["FiftyBanner"] = "FiftyBanner";
    EditorialContentType["FrequentlyAskedQuestions"] = "FrequentlyAskedQuestions";
    EditorialContentType["Header"] = "Header";
    EditorialContentType["Highlights"] = "Highlights";
    EditorialContentType["HowToUse"] = "HowToUse";
    EditorialContentType["LinkCarousel"] = "LinkCarousel";
    EditorialContentType["LinkList"] = "LinkList";
    EditorialContentType["MixedPlpContent"] = "MixedPlpContent";
    EditorialContentType["Olapic"] = "Olapic";
    EditorialContentType["ProductBoxCarousel"] = "ProductBoxCarousel";
    EditorialContentType["Table"] = "Table";
    EditorialContentType["TestimonialCarousel"] = "TestimonialCarousel";
    return EditorialContentType;
}({});
/** Editorial header */ /** Editorial Olapic */ /** Editorial PLP Promo Banner */ /** Editorial PLP banner size */ let EditorialPlpPromoBannerSize = exports.EditorialPlpPromoBannerSize = /*#__PURE__*/ function(EditorialPlpPromoBannerSize) {
    EditorialPlpPromoBannerSize["Size1"] = "Size1";
    EditorialPlpPromoBannerSize["Size2"] = "Size2";
    return EditorialPlpPromoBannerSize;
}({});
/** Rows composing product listing page */ /** Rows composing product listing page */ /** Editorial Product Box Carousel */ /** Single testimonial displayed on editorial */ /** Carousel with testimonials to be displayed on editorial */ /** Product recommended as a result of an answer */ let EvaluationFilterType = exports.EvaluationFilterType = /*#__PURE__*/ function(EvaluationFilterType) {
    EvaluationFilterType["All"] = "All";
    EvaluationFilterType["Allowed"] = "Allowed";
    EvaluationFilterType["Blocked"] = "Blocked";
    return EvaluationFilterType;
}({});
/** Used to describe if the report feature is enabled, disabled or requires a check of approvals */ let FeatureAccessMode = exports.FeatureAccessMode = /*#__PURE__*/ function(FeatureAccessMode) {
    FeatureAccessMode["CheckApproval"] = "CHECK_APPROVAL";
    FeatureAccessMode["No"] = "NO";
    FeatureAccessMode["Yes"] = "YES";
    return FeatureAccessMode;
}({});
/** Feedback Benefit Banner type */ let FeedbackBenefitBannerType = exports.FeedbackBenefitBannerType = /*#__PURE__*/ function(FeedbackBenefitBannerType) {
    FeedbackBenefitBannerType["Cashback"] = "Cashback";
    FeedbackBenefitBannerType["ShareAndEarn"] = "ShareAndEarn";
    return FeedbackBenefitBannerType;
}({});
let ForeignRegistrationOrigin = exports.ForeignRegistrationOrigin = /*#__PURE__*/ function(ForeignRegistrationOrigin) {
    ForeignRegistrationOrigin["HomeCountryChange"] = "HOME_COUNTRY_CHANGE";
    ForeignRegistrationOrigin["RegistrationForm"] = "REGISTRATION_FORM";
    ForeignRegistrationOrigin["ShareAndEarn"] = "SHARE_AND_EARN";
    ForeignRegistrationOrigin["Termination"] = "TERMINATION";
    return ForeignRegistrationOrigin;
}({});
let ForeignRegistrationStatus = exports.ForeignRegistrationStatus = /*#__PURE__*/ function(ForeignRegistrationStatus) {
    ForeignRegistrationStatus["Active"] = "ACTIVE";
    ForeignRegistrationStatus["Terminated"] = "TERMINATED";
    return ForeignRegistrationStatus;
}({});
/** Enum gender */ let Gender = exports.Gender = /*#__PURE__*/ function(Gender) {
    Gender["Man"] = "Man";
    Gender["Other"] = "Other";
    Gender["Woman"] = "Woman";
    return Gender;
}({});
let HintCategory = exports.HintCategory = /*#__PURE__*/ function(HintCategory) {
    /** Pending back-orders (Reserve) */ HintCategory["BackOrders"] = "BackOrders";
    /** Activity program (Program status) */ HintCategory["Campaign"] = "Campaign";
    /** Pending wish-list for end-consumer (Customer order) */ HintCategory["EndConsumerOrders"] = "EndConsumerOrders";
    /** Generic message */ HintCategory["General"] = "General";
    /** Merchandising offer (Offer) */ HintCategory["Offer"] = "Offer";
    /** Welcome program 1-6 campaign */ HintCategory["WelcomeProgram"] = "WelcomeProgram";
    return HintCategory;
}({});
let HintType = exports.HintType = /*#__PURE__*/ function(HintType) {
    /** Shopping advice */ HintType["Advice"] = "Advice";
    /** Important alert */ HintType["Alert"] = "Alert";
    /** Delivery section hint */ HintType["Delivery"] = "Delivery";
    /** Merchandising hint generated by shopping rule-engine */ HintType["Generated"] = "Generated";
    /** Generic information */ HintType["Information"] = "Information";
    return HintType;
}({});
let HorizontalContentAlignment = exports.HorizontalContentAlignment = /*#__PURE__*/ function(HorizontalContentAlignment) {
    HorizontalContentAlignment["Left"] = "Left";
    HorizontalContentAlignment["Right"] = "Right";
    HorizontalContentAlignment["Undefined"] = "Undefined";
    return HorizontalContentAlignment;
}({});
/** Contains information about an image item. */ /** The concept resolver. */ /** The concept resolver. */ /** The concept resolver. */ /** Enum language type */ let LanguageType = exports.LanguageType = /*#__PURE__*/ function(LanguageType) {
    LanguageType["Alternative"] = "Alternative";
    LanguageType["Default"] = "Default";
    return LanguageType;
}({});
let LinkType = exports.LinkType = /*#__PURE__*/ function(LinkType) {
    LinkType["Brand"] = "Brand";
    LinkType["Brands"] = "Brands";
    LinkType["Campaign"] = "Campaign";
    LinkType["Catalogue"] = "Catalogue";
    LinkType["Category"] = "Category";
    LinkType["CategoryNavigation"] = "CategoryNavigation";
    LinkType["Custom"] = "Custom";
    LinkType["DigitalCatalogueCurrentNavigation"] = "DigitalCatalogueCurrentNavigation";
    LinkType["EditorialArticle"] = "EditorialArticle";
    LinkType["EditorialCampaign"] = "EditorialCampaign";
    LinkType["FoundationFinder"] = "FoundationFinder";
    LinkType["Frontpage"] = "Frontpage";
    LinkType["Ingredient"] = "Ingredient";
    LinkType["InvitationOffer"] = "InvitationOffer";
    LinkType["Invite"] = "Invite";
    LinkType["NewProducts"] = "NewProducts";
    LinkType["NovageSkincareAdvisor"] = "NovageSkincareAdvisor";
    LinkType["PlPage"] = "PlPage";
    LinkType["Product"] = "Product";
    LinkType["RegistrationPage"] = "RegistrationPage";
    LinkType["SignIn"] = "SignIn";
    LinkType["VirtualTryOn"] = "VirtualTryOn";
    return LinkType;
}({});
let ManagerSummitStatus = exports.ManagerSummitStatus = /*#__PURE__*/ function(ManagerSummitStatus) {
    ManagerSummitStatus["NotAvailable"] = "NotAvailable";
    ManagerSummitStatus["QualificationInProgress"] = "QualificationInProgress";
    ManagerSummitStatus["QualifiedBeforeCutOff"] = "QualifiedBeforeCutOff";
    ManagerSummitStatus["QualifiedIncludingCutOff"] = "QualifiedIncludingCutOff";
    return ManagerSummitStatus;
}({});
let ManagerSummitVersion = exports.ManagerSummitVersion = /*#__PURE__*/ function(ManagerSummitVersion) {
    ManagerSummitVersion["Manager"] = "Manager";
    ManagerSummitVersion["NewComer"] = "NewComer";
    ManagerSummitVersion["NotAvailable"] = "NotAvailable";
    return ManagerSummitVersion;
}({});
let MobileAppType = exports.MobileAppType = /*#__PURE__*/ function(MobileAppType) {
    MobileAppType["None"] = "None";
    MobileAppType["ToSell"] = "ToSell";
    MobileAppType["ToShop"] = "ToShop";
    return MobileAppType;
}({});
/** Possible types of Navigation items */ let NavigationLinkType = exports.NavigationLinkType = /*#__PURE__*/ function(NavigationLinkType) {
    /** All category */ NavigationLinkType["AllCategory"] = "AllCategory";
    /** Beauty Tips section */ NavigationLinkType["BeautyTips"] = "BeautyTips";
    /** Bestseller products page */ NavigationLinkType["Bestsellers"] = "Bestsellers";
    /** Bestseller products in category */ NavigationLinkType["BestsellersInCategory"] = "BestsellersInCategory";
    /** Bottom part of the footer */ NavigationLinkType["Bottom"] = "Bottom";
    /** Bottom part of the footer with copyright info */ NavigationLinkType["BottomCopyright"] = "BottomCopyright";
    /** Links from the bottom part of the footer */ NavigationLinkType["BottomLinks"] = "BottomLinks";
    /** Catalogue page */ NavigationLinkType["Catalogue"] = "Catalogue";
    /** Catalogues page */ NavigationLinkType["Catalogues"] = "Catalogues";
    /** Category */ NavigationLinkType["Category"] = "Category";
    /** Catalogue for the current period */ NavigationLinkType["DigitalCatalogueCurrent"] = "DigitalCatalogueCurrent";
    /** Catalogue for the next period */ NavigationLinkType["DigitalCatalogueNext"] = "DigitalCatalogueNext";
    /** Focus page */ NavigationLinkType["FocusPage"] = "FocusPage";
    /** Column of a footer */ NavigationLinkType["FooterColumn"] = "FooterColumn";
    /** Item placed in footer's column */ NavigationLinkType["FooterColumnItem"] = "FooterColumnItem";
    /** Gifts section */ NavigationLinkType["Gifts"] = "Gifts";
    /** I Don't know yet link */ NavigationLinkType["IDontKnowYet"] = "IDontKnowYet";
    /** Iconic products page */ NavigationLinkType["Icons"] = "Icons";
    /** Iconic products in category */ NavigationLinkType["IconsInCategory"] = "IconsInCategory";
    /** Inspiration section */ NavigationLinkType["Inspiration"] = "Inspiration";
    /** Join rewards */ NavigationLinkType["JoinRewards"] = "JoinRewards";
    /** Key ingredients page */ NavigationLinkType["KeyIngredients"] = "KeyIngredients";
    /** Menu tiles */ NavigationLinkType["MenuTiles"] = "MenuTiles";
    /** New products */ NavigationLinkType["New"] = "New";
    /** No link type was specified for this item */ NavigationLinkType["None"] = "None";
    /** Our applications */ NavigationLinkType["OurApps"] = "OurApps";
    /** Outlet shop */ NavigationLinkType["OutletShop"] = "OutletShop";
    /** Payment method */ NavigationLinkType["PaymentMethod"] = "PaymentMethod";
    /** Available payment methods */ NavigationLinkType["PaymentMethods"] = "PaymentMethods";
    /** Popular brand */ NavigationLinkType["PopularBrand"] = "PopularBrand";
    /** Popular brands */ NavigationLinkType["PopularBrands"] = "PopularBrands";
    /** Popular lookbook */ NavigationLinkType["PopularLookbook"] = "PopularLookbook";
    /** Turkish QR code */ NavigationLinkType["Qrtr"] = "QRTR";
    /** Rewards shop page */ NavigationLinkType["RewardsShop"] = "RewardsShop";
    /** Sample shop page */ NavigationLinkType["SampleShop"] = "SampleShop";
    /** Segment of subcategory */ NavigationLinkType["Segment"] = "Segment";
    /** Subcategory */ NavigationLinkType["SubCategory"] = "SubCategory";
    /** Support center */ NavigationLinkType["SupportCenter"] = "SupportCenter";
    /** Top navigation */ NavigationLinkType["TopNavigation"] = "TopNavigation";
    /** What's new in the category */ NavigationLinkType["WhatsNewInCategory"] = "WhatsNewInCategory";
    return NavigationLinkType;
}({});
/** Possible types of navigations */ let NavigationType = exports.NavigationType = /*#__PURE__*/ function(NavigationType) {
    /** About tiles section content */ NavigationType["AboutTiles"] = "AboutTiles";
    /** Footer section */ NavigationType["Footer"] = "Footer";
    /** Inspiration tiles content */ NavigationType["InspirationTiles"] = "InspirationTiles";
    /** Join section content */ NavigationType["JoinTiles"] = "JoinTiles";
    /** Shop section content */ NavigationType["ShopSection"] = "ShopSection";
    /** Top area navigation menu */ NavigationType["TopAreaNavigation"] = "TopAreaNavigation";
    /** Top navigation bar items */ NavigationType["TopNavigation"] = "TopNavigation";
    return NavigationType;
}({});
let NotificationAppearance = exports.NotificationAppearance = /*#__PURE__*/ function(NotificationAppearance) {
    NotificationAppearance["All"] = "All";
    NotificationAppearance["Beauty"] = "Beauty";
    NotificationAppearance["Delivery"] = "Delivery";
    NotificationAppearance["Information"] = "Information";
    NotificationAppearance["Offers"] = "Offers";
    NotificationAppearance["Payments"] = "Payments";
    NotificationAppearance["Review"] = "Review";
    NotificationAppearance["ShopppingBag"] = "ShopppingBag";
    NotificationAppearance["Subscriptions"] = "Subscriptions";
    return NotificationAppearance;
}({});
let NotificationBannerThemeType = exports.NotificationBannerThemeType = /*#__PURE__*/ function(NotificationBannerThemeType) {
    NotificationBannerThemeType["Black"] = "Black";
    NotificationBannerThemeType["Grey"] = "Grey";
    return NotificationBannerThemeType;
}({});
/** Olapic type enumeration */ let OlapicTypeEnum = exports.OlapicTypeEnum = /*#__PURE__*/ function(OlapicTypeEnum) {
    /** Category widget */ OlapicTypeEnum["Category"] = "Category";
    /** Front page widget */ OlapicTypeEnum["FrontPage"] = "FrontPage";
    /** Gallery widget */ OlapicTypeEnum["Gallery"] = "Gallery";
    /** Product detail page widget */ OlapicTypeEnum["ProductDetails"] = "ProductDetails";
    return OlapicTypeEnum;
}({});
let OrderDocumentType = exports.OrderDocumentType = /*#__PURE__*/ function(OrderDocumentType) {
    OrderDocumentType["FiscalReceipt"] = "FiscalReceipt";
    OrderDocumentType["InvoicePdf"] = "InvoicePdf";
    OrderDocumentType["InvoiceXml"] = "InvoiceXml";
    OrderDocumentType["ReturnFiscalReceipt"] = "ReturnFiscalReceipt";
    return OrderDocumentType;
}({});
let OrderHistoryType = exports.OrderHistoryType = /*#__PURE__*/ function(OrderHistoryType) {
    OrderHistoryType["Claimable"] = "Claimable";
    OrderHistoryType["Full"] = "Full";
    OrderHistoryType["Last3Periods"] = "Last3Periods";
    return OrderHistoryType;
}({});
let OrderItemType = exports.OrderItemType = /*#__PURE__*/ function(OrderItemType) {
    OrderItemType["BackOrder"] = "BackOrder";
    OrderItemType["Bundle"] = "Bundle";
    OrderItemType["Donation"] = "Donation";
    OrderItemType["EndConsumerOrder"] = "EndConsumerOrder";
    OrderItemType["ExtraChange"] = "ExtraChange";
    OrderItemType["ExtraSold"] = "ExtraSold";
    OrderItemType["ExtraTax"] = "ExtraTax";
    OrderItemType["Fee"] = "Fee";
    OrderItemType["FreeSample"] = "FreeSample";
    OrderItemType["FreeShippingJoker"] = "FreeShippingJoker";
    OrderItemType["MerchandisingChange"] = "MerchandisingChange";
    OrderItemType["MerchandisingChangedGift"] = "MerchandisingChangedGift";
    OrderItemType["MerchandisingDiscount"] = "MerchandisingDiscount";
    OrderItemType["MerchandisingGift"] = "MerchandisingGift";
    OrderItemType["NextOrderDelivery"] = "NextOrderDelivery";
    OrderItemType["Offer"] = "Offer";
    OrderItemType["PaymentFee"] = "PaymentFee";
    OrderItemType["PersonalNutrition"] = "PersonalNutrition";
    OrderItemType["PersonalSubscription"] = "PersonalSubscription";
    OrderItemType["Product"] = "Product";
    OrderItemType["RegistrationFee"] = "RegistrationFee";
    OrderItemType["RenewalFee"] = "RenewalFee";
    OrderItemType["Replacement"] = "Replacement";
    OrderItemType["Reservation"] = "Reservation";
    OrderItemType["Section1"] = "Section1";
    OrderItemType["Section2"] = "Section2";
    OrderItemType["Section3"] = "Section3";
    OrderItemType["Section4"] = "Section4";
    OrderItemType["Service"] = "Service";
    OrderItemType["StarterKit"] = "StarterKit";
    OrderItemType["Subscription"] = "Subscription";
    OrderItemType["Target"] = "Target";
    OrderItemType["Unknown"] = "Unknown";
    OrderItemType["Voucher"] = "Voucher";
    return OrderItemType;
}({});
let OrderOrigin = exports.OrderOrigin = /*#__PURE__*/ function(OrderOrigin) {
    OrderOrigin["Automatic"] = "Automatic";
    OrderOrigin["Bambuser"] = "Bambuser";
    OrderOrigin["Claim"] = "Claim";
    OrderOrigin["Demo"] = "Demo";
    OrderOrigin["Email"] = "Email";
    OrderOrigin["Immediate"] = "Immediate";
    OrderOrigin["Internal"] = "Internal";
    OrderOrigin["NowApp"] = "NowApp";
    OrderOrigin["OnBehalf"] = "OnBehalf";
    OrderOrigin["Online"] = "Online";
    OrderOrigin["Orisales"] = "Orisales";
    OrderOrigin["Other"] = "Other";
    OrderOrigin["Pbs"] = "Pbs";
    OrderOrigin["Pharmacy"] = "Pharmacy";
    OrderOrigin["Registration"] = "Registration";
    OrderOrigin["Telephone"] = "Telephone";
    OrderOrigin["Vip"] = "Vip";
    OrderOrigin["WeChat"] = "WeChat";
    OrderOrigin["WeChatApp"] = "WeChatApp";
    return OrderOrigin;
}({});
let OrderStatus = exports.OrderStatus = /*#__PURE__*/ function(OrderStatus) {
    OrderStatus["All"] = "All";
    OrderStatus["Blocked"] = "Blocked";
    OrderStatus["CancelRequested"] = "CancelRequested";
    OrderStatus["Canceled"] = "Canceled";
    OrderStatus["CreditNote"] = "CreditNote";
    OrderStatus["Paid"] = "Paid";
    OrderStatus["Pending"] = "Pending";
    OrderStatus["Unpaid"] = "Unpaid";
    OrderStatus["Waiting"] = "Waiting";
    OrderStatus["WaitingForApproval"] = "WaitingForApproval";
    return OrderStatus;
}({});
/** Payment Channel for bonus type */ let PaymentChannel = exports.PaymentChannel = /*#__PURE__*/ function(PaymentChannel) {
    /** Commission payment channel (BonusType released to bank account) */ PaymentChannel["Commission"] = "Commission";
    /** Discount payment channel (BonusType released to discount) */ PaymentChannel["Discount"] = "Discount";
    /** Immediate payment channel (BonusType send as event ImmediatePaymentCalculatedEvent) */ PaymentChannel["ImmediateCommission"] = "ImmediateCommission";
    /** Sales Action Discount (BonusType not released - used for virtual income i.e. immediate profit) */ PaymentChannel["SalesActionDiscount"] = "SalesActionDiscount";
    return PaymentChannel;
}({});
/** Payment method type */ let PaymentMethodType = exports.PaymentMethodType = /*#__PURE__*/ function(PaymentMethodType) {
    /** Oriflame credit (blocked) */ PaymentMethodType["BlockedInvoice"] = "BlockedInvoice";
    /** Cash on delivery by courier */ PaymentMethodType["CashOnDelivery"] = "CashOnDelivery";
    /** Cash (immediate) payment */ PaymentMethodType["CashPayment"] = "CashPayment";
    /** Oriflame credit */ PaymentMethodType["Invoice"] = "Invoice";
    /** No payment is needed */ PaymentMethodType["NoPayment"] = "NoPayment";
    /** Online payments */ PaymentMethodType["Online"] = "Online";
    /** Waiting for transfer */ PaymentMethodType["WaitingForTransfer"] = "WaitingForTransfer";
    return PaymentMethodType;
}({});
/** Payment provider */ let PeriodStatus = exports.PeriodStatus = /*#__PURE__*/ function(PeriodStatus) {
    PeriodStatus["ActiveCompleted"] = "ActiveCompleted";
    PeriodStatus["ActiveNotCompleted"] = "ActiveNotCompleted";
    PeriodStatus["Completed"] = "Completed";
    PeriodStatus["NotActive"] = "NotActive";
    PeriodStatus["NotCompleted"] = "NotCompleted";
    return PeriodStatus;
}({});
let PermanentTopBannerType = exports.PermanentTopBannerType = /*#__PURE__*/ function(PermanentTopBannerType) {
    /** All pages behind Checkout */ PermanentTopBannerType["Checkout"] = "Checkout";
    /** All pages behind my-pages */ PermanentTopBannerType["MyPages"] = "MyPages";
    /** All other public pages */ PermanentTopBannerType["PublicPage"] = "PublicPage";
    /** All public pages with provided referral parameter */ PermanentTopBannerType["PublicPageWithReferral"] = "PublicPageWithReferral";
    return PermanentTopBannerType;
}({});
let PersonalSubscriptionCategory = exports.PersonalSubscriptionCategory = /*#__PURE__*/ function(PersonalSubscriptionCategory) {
    PersonalSubscriptionCategory["PersonalNutrition"] = "PersonalNutrition";
    PersonalSubscriptionCategory["Product"] = "Product";
    return PersonalSubscriptionCategory;
}({});
let PickupSearchFilter = exports.PickupSearchFilter = /*#__PURE__*/ function(PickupSearchFilter) {
    PickupSearchFilter["All"] = "All";
    PickupSearchFilter["DepartmentStore"] = "DepartmentStore";
    PickupSearchFilter["Lpo"] = "Lpo";
    PickupSearchFilter["MySpo"] = "MySpo";
    PickupSearchFilter["PickupPoint"] = "PickupPoint";
    PickupSearchFilter["PostOffice"] = "PostOffice";
    PickupSearchFilter["PremiumSpo"] = "PremiumSpo";
    PickupSearchFilter["Spo"] = "Spo";
    return PickupSearchFilter;
}({});
let PlpOrderBy = exports.PlpOrderBy = /*#__PURE__*/ function(PlpOrderBy) {
    PlpOrderBy["HighestDiscount"] = "HighestDiscount";
    PlpOrderBy["HighestPrice"] = "HighestPrice";
    PlpOrderBy["HighestRating"] = "HighestRating";
    PlpOrderBy["Latest"] = "Latest";
    PlpOrderBy["LowestPrice"] = "LowestPrice";
    PlpOrderBy["Recommended"] = "Recommended";
    return PlpOrderBy;
}({});
/** The product resolver. */ /** The product resolver. */ /** The product resolver. */ /** The product resolver. */ /** The product resolver. */ /** Product Label Domain Type */ let ProductLabelDomainType = exports.ProductLabelDomainType = /*#__PURE__*/ function(ProductLabelDomainType) {
    /** Only Offer, New, SuperDeal */ ProductLabelDomainType["Deal"] = "Deal";
    ProductLabelDomainType["Ppa"] = "PPA";
    /** Domain Type for AddToBasketVisible ProductLabelType */ ProductLabelDomainType["Shopping"] = "Shopping";
    return ProductLabelDomainType;
}({});
let ProductListType = exports.ProductListType = /*#__PURE__*/ function(ProductListType) {
    ProductListType["Favorite"] = "Favorite";
    ProductListType["Personal"] = "Personal";
    ProductListType["Private"] = "Private";
    ProductListType["Wishlist"] = "Wishlist";
    return ProductListType;
}({});
/** Enum ProductListingBannerVideoType */ let ProductListingBannerVideoType = exports.ProductListingBannerVideoType = /*#__PURE__*/ function(ProductListingBannerVideoType) {
    ProductListingBannerVideoType["Mp4"] = "Mp4";
    ProductListingBannerVideoType["None"] = "None";
    ProductListingBannerVideoType["Youku"] = "Youku";
    ProductListingBannerVideoType["Youtube"] = "Youtube";
    return ProductListingBannerVideoType;
}({});
/** The product recommendation resolver. */ let ProductRelationType = exports.ProductRelationType = /*#__PURE__*/ function(ProductRelationType) {
    ProductRelationType["Favourite"] = "Favourite";
    ProductRelationType["Popular"] = "Popular";
    ProductRelationType["RecentlyViewed"] = "RecentlyViewed";
    ProductRelationType["Related"] = "Related";
    ProductRelationType["Samples"] = "Samples";
    return ProductRelationType;
}({});
let ProductReplacementType = exports.ProductReplacementType = /*#__PURE__*/ function(ProductReplacementType) {
    /** Alternative replacement. */ ProductReplacementType["Alternative"] = "Alternative";
    /** Automatic replacement without interaction with user. */ ProductReplacementType["Automatic"] = "Automatic";
    /** Manual replacement during shopping. */ ProductReplacementType["Manual"] = "Manual";
    /** Taste replacement of subscribed product. */ ProductReplacementType["Subscription"] = "Subscription";
    /** Automatic replacement of subscribed wellness product without interaction with user. */ ProductReplacementType["WellnessAutomatic"] = "WellnessAutomatic";
    /** Manual replacement of subscribed wellness product during shopping. */ ProductReplacementType["WellnessManual"] = "WellnessManual";
    return ProductReplacementType;
}({});
/** Represents the results of a product search. */ let ProductType = exports.ProductType = /*#__PURE__*/ function(ProductType) {
    ProductType["Bundle"] = "Bundle";
    ProductType["Composite"] = "Composite";
    ProductType["Fee"] = "Fee";
    ProductType["Product"] = "Product";
    ProductType["Sample"] = "Sample";
    return ProductType;
}({});
/** Product with available dosage information */ /** Voucher promotion */ let PromotionType = exports.PromotionType = /*#__PURE__*/ function(PromotionType) {
    /** End-consumers promotion code */ PromotionType["CustomerPromoCode"] = "CustomerPromoCode";
    /** Discount (amount/price) */ PromotionType["FixedDiscount"] = "FixedDiscount";
    /** Shipping for free */ PromotionType["FreeShipping"] = "FreeShipping";
    /** Voucher with amount which could be used for payment */ PromotionType["GiftCard"] = "GiftCard";
    /** Member get member */ PromotionType["Mgm"] = "Mgm";
    /** Discount (%) */ PromotionType["PercentageDiscount"] = "PercentageDiscount";
    /** Promotion code */ PromotionType["PromoCode"] = "PromoCode";
    /** Nova RaF promotion */ PromotionType["RecommendAFriend"] = "RecommendAFriend";
    /** 2nd step of MGM - referral benefit */ PromotionType["Referral"] = "Referral";
    PromotionType["Unknown"] = "Unknown";
    return PromotionType;
}({});
/** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** The query. */ /** Type of question */ let QuestionType = exports.QuestionType = /*#__PURE__*/ function(QuestionType) {
    /** Question allowing multiple selections. */ QuestionType["Multiselect"] = "Multiselect";
    /** Question allowing multiple selections in a grid format. */ QuestionType["MultiselectGrid"] = "MultiselectGrid";
    /** Question with a single answer. */ QuestionType["SingleAnswer"] = "SingleAnswer";
    /** Unknown question type. */ QuestionType["Unknown"] = "Unknown";
    return QuestionType;
}({});
/** One possible answer to a quiz question */ /** Icon to show alongside an answer */ let QuizAnswerIcon = exports.QuizAnswerIcon = /*#__PURE__*/ function(QuizAnswerIcon) {
    /** Bones and joints icon. */ QuizAnswerIcon["BonesJoints"] = "BonesJoints";
    /** Cognition and memory icon. */ QuizAnswerIcon["CognitionMemory"] = "CognitionMemory";
    /** Energy and focus icon. */ QuizAnswerIcon["EnergyFocus"] = "EnergyFocus";
    /** Eyes icon. */ QuizAnswerIcon["Eyes"] = "Eyes";
    /** Fitness icon. */ QuizAnswerIcon["Fitness"] = "Fitness";
    /** General wellness icon. */ QuizAnswerIcon["GeneralWellness"] = "GeneralWellness";
    /** Gut and digestion icon. */ QuizAnswerIcon["GutDigestion"] = "GutDigestion";
    /** Hair and nails icon. */ QuizAnswerIcon["HairNails"] = "HairNails";
    /** Heart and medical icon. */ QuizAnswerIcon["HeartMedical"] = "HeartMedical";
    /** Immunity icon. */ QuizAnswerIcon["Immunity"] = "Immunity";
    /** No icon. */ QuizAnswerIcon["None"] = "None";
    /** Skin health icon. */ QuizAnswerIcon["SkinHealth"] = "SkinHealth";
    /** Sleep icon. */ QuizAnswerIcon["Sleep"] = "Sleep";
    /** Stress icon. */ QuizAnswerIcon["Stress"] = "Stress";
    /** Women's health icon. */ QuizAnswerIcon["WomensHealth"] = "WomensHealth";
    return QuizAnswerIcon;
}({});
/** One possible result of selecting an answer */ /** Conditions that must be met for a question/answer/result to be shown/considered */ /** Single quiz question */ /** Configuration for a question */ /** Group of questions in the quiz */ /** Quiz termination details */ let ReplacementType = exports.ReplacementType = /*#__PURE__*/ function(ReplacementType) {
    ReplacementType["Alternative"] = "Alternative";
    ReplacementType["Automatic"] = "Automatic";
    ReplacementType["Manual"] = "Manual";
    return ReplacementType;
}({});
let ReportType = exports.ReportType = /*#__PURE__*/ function(ReportType) {
    ReportType["BcmNewActivity"] = "BCM_NEW_ACTIVITY";
    return ReportType;
}({});
let ReportsVisitorSegment = exports.ReportsVisitorSegment = /*#__PURE__*/ function(ReportsVisitorSegment) {
    /** Anonymous */ ReportsVisitorSegment["Anonymous"] = "ANONYMOUS";
    /** Consultant */ ReportsVisitorSegment["Consultant"] = "CONSULTANT";
    /** Director and above */ ReportsVisitorSegment["DirectorAndAbove"] = "DIRECTOR_AND_ABOVE";
    /** End customer */ ReportsVisitorSegment["EndCustomer"] = "END_CUSTOMER";
    /** Manager */ ReportsVisitorSegment["Manager"] = "MANAGER";
    /** Member */ ReportsVisitorSegment["Member"] = "MEMBER";
    /** New consultant */ ReportsVisitorSegment["NewConsultant"] = "NEW_CONSULTANT";
    ReportsVisitorSegment["NotDefined"] = "NOT_DEFINED";
    /** Spo */ ReportsVisitorSegment["Spo"] = "SPO";
    return ReportsVisitorSegment;
}({});
/** ResponseMessageNewsletterSubsciptionsType */ let ResponseMessageNewsletterSubsciptionsType = exports.ResponseMessageNewsletterSubsciptionsType = /*#__PURE__*/ function(ResponseMessageNewsletterSubsciptionsType) {
    /** Cleaned */ ResponseMessageNewsletterSubsciptionsType["Cleaned"] = "Cleaned";
    /** New */ ResponseMessageNewsletterSubsciptionsType["New"] = "New";
    /** Pending */ ResponseMessageNewsletterSubsciptionsType["Pending"] = "Pending";
    /** Subscribed */ ResponseMessageNewsletterSubsciptionsType["Subscribed"] = "Subscribed";
    /** Unsubscribed */ ResponseMessageNewsletterSubsciptionsType["Unsubscribed"] = "Unsubscribed";
    return ResponseMessageNewsletterSubsciptionsType;
}({});
let SettingsClientType = exports.SettingsClientType = /*#__PURE__*/ function(SettingsClientType) {
    SettingsClientType["OnlineReportingGrid"] = "OnlineReportingGrid";
    SettingsClientType["WellnessClub"] = "WellnessClub";
    return SettingsClientType;
}({});
let SettingsFormatType = exports.SettingsFormatType = /*#__PURE__*/ function(SettingsFormatType) {
    SettingsFormatType["Json"] = "Json";
    SettingsFormatType["String"] = "String";
    SettingsFormatType["Xml"] = "Xml";
    return SettingsFormatType;
}({});
/** SharingApp application */ /** SharingApp application */ /** Shopping query root */ /** Shopping query root */ /** Shopping query root */ /** Shopping query root */ /** Shopping query root */ let ShoppingMessageType = exports.ShoppingMessageType = /*#__PURE__*/ function(ShoppingMessageType) {
    /** Delivery related */ ShoppingMessageType["Delivery"] = "Delivery";
    /** Shopping notifications */ ShoppingMessageType["Notifications"] = "Notifications";
    /** Offers related */ ShoppingMessageType["Offers"] = "Offers";
    /** Shopping restrictions */ ShoppingMessageType["Restrictions"] = "Restrictions";
    /** Order review related */ ShoppingMessageType["Review"] = "Review";
    /** Shopping bag related */ ShoppingMessageType["ShoppingBag"] = "ShoppingBag";
    return ShoppingMessageType;
}({});
/** Live video show type */ let ShowType = exports.ShowType = /*#__PURE__*/ function(ShowType) {
    /** Show is recorded */ ShowType["Ended"] = "Ended";
    /** Show is running now */ ShowType["Live"] = "Live";
    /** Show not started yet */ ShowType["Scheduled"] = "Scheduled";
    return ShowType;
}({});
/** Types of social contact */ let SocialContactType = exports.SocialContactType = /*#__PURE__*/ function(SocialContactType) {
    /** Email */ SocialContactType["Email"] = "Email";
    /** Facebook */ SocialContactType["Facebook"] = "Facebook";
    /** Phone */ SocialContactType["PhoneNumber"] = "PhoneNumber";
    /** VKontakte */ SocialContactType["VKontakte"] = "VKontakte";
    /** WeChat */ SocialContactType["WeChat"] = "WeChat";
    /** WhatsUp */ SocialContactType["WhatsUpNumber"] = "WhatsUpNumber";
    return SocialContactType;
}({});
/** Types of social media */ let SocialMediaType = exports.SocialMediaType = /*#__PURE__*/ function(SocialMediaType) {
    /** Facebook */ SocialMediaType["Facebook"] = "Facebook";
    /** Instagram */ SocialMediaType["Instagram"] = "Instagram";
    /** Line */ SocialMediaType["Line"] = "Line";
    /** Odnoklassniki */ SocialMediaType["Odnoklassniki"] = "Odnoklassniki";
    /** Pinterest */ SocialMediaType["Pinterest"] = "Pinterest";
    SocialMediaType["Qq"] = "Qq";
    /** Telegram */ SocialMediaType["Telegram"] = "Telegram";
    /** Twitter */ SocialMediaType["Twitter"] = "Twitter";
    /** VKontakte */ SocialMediaType["VKontakte"] = "VKontakte";
    /** WeChat */ SocialMediaType["WeChat"] = "WeChat";
    /** Weibo */ SocialMediaType["Weibo"] = "Weibo";
    /** YouTube */ SocialMediaType["YouTube"] = "YouTube";
    /** Youku */ SocialMediaType["Youku"] = "Youku";
    return SocialMediaType;
}({});
let SortMode = exports.SortMode = /*#__PURE__*/ function(SortMode) {
    SortMode["Asc"] = "ASC";
    SortMode["Desc"] = "DESC";
    SortMode["None"] = "NONE";
    return SortMode;
}({});
/** Sponsor type */ let SponsorType = exports.SponsorType = /*#__PURE__*/ function(SponsorType) {
    SponsorType["DirectSponsor"] = "DirectSponsor";
    return SponsorType;
}({});
/** Colors enum referring to FE storybook */ let StorybookColor = exports.StorybookColor = /*#__PURE__*/ function(StorybookColor) {
    /** Shades/palette.blue[100] */ StorybookColor["Blue100"] = "Blue100";
    /** Shades/palette.brown[50] */ StorybookColor["Brown50"] = "Brown50";
    /** Shades/palette.brown[100] */ StorybookColor["Brown100"] = "Brown100";
    /** Shades/palette.brown[300] */ StorybookColor["Brown300"] = "Brown300";
    /** Shades/palette.brown[400] */ StorybookColor["Brown400"] = "Brown400";
    /** Extra colors/palette.common.black */ StorybookColor["CommonBlack"] = "CommonBlack";
    /** Extra colors/palette.common.white */ StorybookColor["CommonWhite"] = "CommonWhite";
    /** Palette - Main colors/palette.default.contrastText */ StorybookColor["DefaultContrastText"] = "DefaultContrastText";
    /** Palette - Main colors/palette.default.main */ StorybookColor["DefaultMain"] = "DefaultMain";
    /** Shades/palette.green[50] */ StorybookColor["Green50"] = "Green50";
    /** Shades/palette.green[200] */ StorybookColor["Green200"] = "Green200";
    /** Shades/palette.green[400] */ StorybookColor["Green400"] = "Green400";
    /** Shades/palette.grey[50] */ StorybookColor["Grey50"] = "Grey50";
    /** Shades/palette.grey[100] */ StorybookColor["Grey100"] = "Grey100";
    /** Shades/palette.grey[700] */ StorybookColor["Grey700"] = "Grey700";
    /** Shades/palette.grey[900] */ StorybookColor["Grey900"] = "Grey900";
    /** InfoDark */ StorybookColor["InfoDark"] = "InfoDark";
    /** Shades/palette.pink[50] */ StorybookColor["Pink50"] = "Pink50";
    /** Shades/palette.pink[300] */ StorybookColor["Pink300"] = "Pink300";
    /** Palette - Main colors/palette.default.primarycontrastText */ StorybookColor["PrimaryContrastText"] = "PrimaryContrastText";
    /** PrimaryLight */ StorybookColor["PrimaryLight"] = "PrimaryLight";
    /** Palette - Main colors/palette.default.primarymain */ StorybookColor["PrimaryMain"] = "PrimaryMain";
    /** Shades/palette.purple[50] */ StorybookColor["Purple50"] = "Purple50";
    /** Shades/palette.purple[200] */ StorybookColor["Purple200"] = "Purple200";
    /** Shades/palette.purple[400] */ StorybookColor["Purple400"] = "Purple400";
    /** Shades/palette.red[50] */ StorybookColor["Red50"] = "Red50";
    /** Palette - Main colors/palette.default.secondaryContrastText */ StorybookColor["SecondaryContrastText"] = "SecondaryContrastText";
    /** Palette - Main colors/palette.secondary.main */ StorybookColor["SecondaryMain"] = "SecondaryMain";
    /** Typography/palette.text.primary */ StorybookColor["TextPrimary"] = "TextPrimary";
    /** Typography/palette.text.secondary */ StorybookColor["TextSecondary"] = "TextSecondary";
    /** Undefined value, its an error when this occurs */ StorybookColor["Undefined"] = "Undefined";
    /** Shades/palette.yellow[50] */ StorybookColor["Yellow50"] = "Yellow50";
    /** Shades/palette.yellow[400] */ StorybookColor["Yellow400"] = "Yellow400";
    return StorybookColor;
}({});
/** Subscription query root */ /** Subscription query root */ /** Subscription query root */ let SubscriptionFailReason = exports.SubscriptionFailReason = /*#__PURE__*/ function(SubscriptionFailReason) {
    /** Customer can't order */ SubscriptionFailReason["CustomerCanNotOrder"] = "CustomerCanNotOrder";
    /** Recurring card is expired */ SubscriptionFailReason["ExpiredRecurringCard"] = "ExpiredRecurringCard";
    /** Selected delivery channel can't be used */ SubscriptionFailReason["InvalidDelivery"] = "InvalidDelivery";
    /** Can't delivery to selected delivery address */ SubscriptionFailReason["InvalidDeliveryAddress"] = "InvalidDeliveryAddress";
    /** Selected payment provider is invalid */ SubscriptionFailReason["InvalidPayment"] = "InvalidPayment";
    /** Customer has no recurring card */ SubscriptionFailReason["MissingRecurringCard"] = "MissingRecurringCard";
    SubscriptionFailReason["None"] = "None";
    /** Order place failed */ SubscriptionFailReason["OrderFailed"] = "OrderFailed";
    /** Product can't be sold */ SubscriptionFailReason["ProductNotFound"] = "ProductNotFound";
    /** Product is out of stock */ SubscriptionFailReason["ProductOutOfStock"] = "ProductOutOfStock";
    /** Product is not present in any catalog */ SubscriptionFailReason["ProductPriceNotFound"] = "ProductPriceNotFound";
    /** Customer is terminated */ SubscriptionFailReason["TerminatedCustomer"] = "TerminatedCustomer";
    return SubscriptionFailReason;
}({});
/** Enum telephone type */ let TelephoneType = exports.TelephoneType = /*#__PURE__*/ function(TelephoneType) {
    TelephoneType["Business"] = "Business";
    TelephoneType["Fax"] = "Fax";
    TelephoneType["Home"] = "Home";
    TelephoneType["Mobile"] = "Mobile";
    return TelephoneType;
}({});
/** Single line of text */ let TrackingStatus = exports.TrackingStatus = /*#__PURE__*/ function(TrackingStatus) {
    TrackingStatus["Cancel"] = "Cancel";
    TrackingStatus["CourierHandover"] = "CourierHandover";
    TrackingStatus["CourierTakeover"] = "CourierTakeover";
    TrackingStatus["Create"] = "Create";
    TrackingStatus["Deliver"] = "Deliver";
    TrackingStatus["EstimatedDelivery"] = "EstimatedDelivery";
    TrackingStatus["HandoverFailed"] = "HandoverFailed";
    TrackingStatus["OutForDelivery"] = "OutForDelivery";
    TrackingStatus["Pick"] = "Pick";
    TrackingStatus["PickedUpBy"] = "PickedUpBy";
    TrackingStatus["Print"] = "Print";
    TrackingStatus["ReadyForPickup"] = "ReadyForPickup";
    TrackingStatus["ReturnedToSender"] = "ReturnedToSender";
    TrackingStatus["Ship"] = "Ship";
    TrackingStatus["TakenByCourier"] = "TakenByCourier";
    TrackingStatus["ToBeReturnedToSender"] = "ToBeReturnedToSender";
    TrackingStatus["Unknown"] = "Unknown";
    return TrackingStatus;
}({});
let ValidationErrorSeverity = exports.ValidationErrorSeverity = /*#__PURE__*/ function(ValidationErrorSeverity) {
    ValidationErrorSeverity["Critical"] = "Critical";
    ValidationErrorSeverity["Warning"] = "Warning";
    return ValidationErrorSeverity;
}({});
let ValidationErrorType = exports.ValidationErrorType = /*#__PURE__*/ function(ValidationErrorType) {
    ValidationErrorType["MinimumRequirementsNotMet"] = "MinimumRequirementsNotMet";
    ValidationErrorType["SafetyLimitsViolated"] = "SafetyLimitsViolated";
    ValidationErrorType["TooManyPills"] = "TooManyPills";
    return ValidationErrorType;
}({});
/** Content vertical alignment */ let VerticalContentAlignment = exports.VerticalContentAlignment = /*#__PURE__*/ function(VerticalContentAlignment) {
    VerticalContentAlignment["Bottom"] = "Bottom";
    VerticalContentAlignment["Middle"] = "Middle";
    VerticalContentAlignment["Top"] = "Top";
    VerticalContentAlignment["Undefined"] = "Undefined";
    return VerticalContentAlignment;
}({});
let VideoType = exports.VideoType = /*#__PURE__*/ function(VideoType) {
    /** Video in MP4 file format */ VideoType["Mp4"] = "Mp4";
    /** Video hosted on Youku */ VideoType["Youku"] = "Youku";
    /** Video hosted on YouTube */ VideoType["Youtube"] = "Youtube";
    return VideoType;
}({});
/** Possible types of visitor segment */ let VisitorSegment = exports.VisitorSegment = /*#__PURE__*/ function(VisitorSegment) {
    /** Anonymous */ VisitorSegment["Anonymous"] = "Anonymous";
    /** Consultant */ VisitorSegment["Consultant"] = "Consultant";
    /** Director and above */ VisitorSegment["DirectorAndAbove"] = "DirectorAndAbove";
    /** End customer */ VisitorSegment["EndCustomer"] = "EndCustomer";
    /** Manager */ VisitorSegment["Manager"] = "Manager";
    /** Member */ VisitorSegment["Member"] = "Member";
    /** New consultant */ VisitorSegment["NewConsultant"] = "NewConsultant";
    /** Not defined */ VisitorSegment["NotDefined"] = "NotDefined";
    /** Spo */ VisitorSegment["Spo"] = "Spo";
    return VisitorSegment;
}({});
let VoucherFlag = exports.VoucherFlag = /*#__PURE__*/ function(VoucherFlag) {
    /** Recurrent voucher with limited usage */ VoucherFlag["MultiUse"] = "MultiUse";
    VoucherFlag["None"] = "None";
    /** Voucher can be used just by assigned person */ VoucherFlag["Personal"] = "Personal";
    /** Voucher can be shared with anyone */ VoucherFlag["ShareWithFriends"] = "ShareWithFriends";
    /** Recurrent voucher with unlimited usage */ VoucherFlag["UnlimitedUse"] = "UnlimitedUse";
    return VoucherFlag;
}({});
